export enum LayoutType {
  CUSTOMER,
  DOCUMENTS,
  BANKING,
}
